import { useCallback } from "react";

import { ForgeTile, PieceName } from "src/api";

import { useGame } from "../../game/GameContext";
import { useSpawnSelection } from "../../game/spawnSelection";
import { useSessionView } from "../../game/useSessionView";
import { type PieceIcons } from "../icons/iconTypes";
import { CollapsingCard } from "../shared/CollapsingCard";
import { CollapsingCardMenu } from "../shared/CollapsingCardMenu";
import { ItemTile } from "../shared/ItemTile";
import iconTool from "./icon-tool.png";

const PIECE_ICONS: Partial<Record<PieceName, PieceIcons>> = {
  pawn: "piecePawn",
  knight: "pieceKnight",
  bishop: "pieceBishop",
  rook: "pieceRook",
  queen: "pieceQueen"
};

export function ForgeMenu() {
  const { session } = useGame();

  const view = useSessionView();
  const pieces = view?.hotbar.forge ?? null;

  const pieceOrStructure = useSpawnSelection((state) => state.pieceOrStructure);
  const selectedPiece =
    pieceOrStructure?.kind === "piece" ? pieceOrStructure.piece : null;

  const onClick = useCallback(
    (piece: ForgeTile) => {
      const outcome = session?.choose(piece.option);
      console.log(outcome);
      useSpawnSelection.setState((state) => ({
        pieceOrStructure:
          state.pieceOrStructure?.kind === "piece" &&
          state.pieceOrStructure.piece === piece.piece
            ? null
            : { kind: "piece", piece: piece.piece }
      }));
    },
    [session]
  );

  const icon = <img src={iconTool} alt="" />;

  return (
    <CollapsingCard icon={icon} tooltip={null}>
      <CollapsingCardMenu>
        {pieces?.map((piece) => {
          const pieceIcon = PIECE_ICONS[piece.piece];
          if (!pieceIcon) return null;
          return (
            <ItemTile
              key={piece.piece}
              icon={pieceIcon}
              rows={piece.rows}
              selected={selectedPiece === piece.piece}
              disabled={piece.forgeable || piece.reason !== null}
              onClick={() => onClick(piece)}
            />
          );
        })}
      </CollapsingCardMenu>
    </CollapsingCard>
  );
}
